import * as THREE from 'three';

export interface CameraAngle {
	name: string;
	zoom: number;
	x: number;
	y: number;
	z: number;
	lookAt: THREE.Vector3;
}

export enum CameraAngleName {
	front = 'front',
	transition = 'transition',
	left = 'left',
	right = 'right',
	frontLeft = 'frontLeft',
	frontRight = 'frontRight',
	topDown = 'topDown',
	topLeft = 'topLeft',
	topRight = 'topRight',
	topDownLeft = 'topDownLeft',
	topDownRight = 'topDownRight',
	sideFromAbove = 'sideFromAbove',
	exerciseHelp = 'exerciseHelp',
	dartboard = 'dartboard',
	grid = 'grid',
}

export const ExerciseCameraAngles: CameraAngle[] = [
	{
		name: CameraAngleName.front,
		x: 0,
		y: 1,
		z: 5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.transition,
		x: 2,
		y: 1,
		z: 5,
		zoom: 1,
		lookAt: new THREE.Vector3(-0.65, 0.75, 0)
	},
	{
		name: CameraAngleName.topLeft,
		x: -4,
		y: 3.5,
		z: 2.5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.topRight,
		x: 4,
		y: 3.5,
		z: 2.5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.left,
		x: -5,
		y: 0.75,
		z: 1.5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.right,
		x: 5,
		y: 0.75,
		z: 1.5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.frontLeft,
		x: -2.5,
		y: 1,
		z: 4.5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.frontRight,
		x: 2.5,
		y: 1,
		z: 4.5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.topDown,
		x: 0,
		y: 5,
		z: -0.1,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.topDownLeft,
		x: 0.6,
		y: 4,
		z: -0.8,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.topDownRight,
		x: -0.6,
		y: 4,
		z: -0.8,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.sideFromAbove,
		x: 3.25,
		y: 4.25,
		z: 0,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.5, 0)
	},
	{
		name: CameraAngleName.exerciseHelp,
		x: 4,
		y: 3.5,
		z: 2.5,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.dartboard,
		x: 0,
		y: 4,
		z: 0.1,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
	{
		name: CameraAngleName.grid,
		x: 0,
		y: 4,
		z: 0.1,
		zoom: 1,
		lookAt: new THREE.Vector3(0, 0.75, 0)
	},
]